import React from "react"
import { motion } from "framer-motion"

export const Hero: React.FC = () => {
	return (
		<section className="flex items-center justify-center min-h-[60vh] bg-[url('/src/assets/hero.jpg')] bg-cover bg-center text-center">
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 1 }}>
				<p className='text-4xl mb-40 text-black'>
					Profesjonalne usługi księgowe dla firm i osób prywatnych
				</p>
				<a
					href='#contact'
					className='bg-accent text-white py-2 px-4 rounded hover:bg-orange-500 transition'>
					Skontaktuj się z nami
				</a>
				<h2 className='text-6xl font-bold mt-8 text-orange-400'>
					Twoje finanse w dobrych rękach
				</h2>
			</motion.div>
		</section>
	)
}
